import { bindRequestLogic } from './utils'
import ConditionalFeatureTypes from '../actionTypes/conditionalFeature'
import { conditionalFeatureAPI } from '../api'

const getConditionalFeatures = bindRequestLogic({
  clientFunc: conditionalFeatureAPI.getConditionalFeatures,
  type: ConditionalFeatureTypes.GET_CONDITIONAL_FEATURE_REQUEST,
  successType: ConditionalFeatureTypes.GET_CONDITIONAL_FEATURE_SUCCESS,
  failType: ConditionalFeatureTypes.GET_CONDITIONAL_FAILED,
  isQueryParam: true
})

const addConditionalFeature = bindRequestLogic({
  clientFunc: conditionalFeatureAPI.addConditionalFeature,
  type: ConditionalFeatureTypes.ADD_CONDITIONAL_FEATURE_REQUEST,
  successType: ConditionalFeatureTypes.ADD_CONDITIONAL_FEATURE_SUCCESS,
  failType: ConditionalFeatureTypes.ADD_CONDITIONAL_FEATURE_FAILED
})

const updateConditionalFeature = bindRequestLogic({
  clientFunc: conditionalFeatureAPI.updateConditionalFeature,
  type: ConditionalFeatureTypes.UPDATE_CONDITIONAL_FEATURE_REQUEST,
  successType: ConditionalFeatureTypes.UPDATE_CONDITIONAL_FEATURE_SUCCESS,
  failType: ConditionalFeatureTypes.UPDATE_CONDITIONAL_FEATURE_FAILED
})

const deleteConditionalFeature = bindRequestLogic({
  clientFunc: conditionalFeatureAPI.deleteConditionalFeature,
  type: ConditionalFeatureTypes.DELETE_CONDITIONAL_FEATURE_REQUEST,
  successType: ConditionalFeatureTypes.DELETE_CONDITIONAL_FEATURE_SUCCESS,
  failType: ConditionalFeatureTypes.DELETE_CONDITIONAL_FEATURE_FAILED
})

export default [
  getConditionalFeatures,
  deleteConditionalFeature,
  updateConditionalFeature,
  addConditionalFeature
]
